import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadNotes } from 'actions';
import { getLoaders, resolveNotesPlayer, resolveNotesPlayerId, resolveNotesQuestionnaireId, resolveNotesSurvey } from 'selectors';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import SurveyNotesContainer from './SurveyNotesContainer';

class SurveyNotesModal extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    survey: PropTypes.object,
    player: PropTypes.object,
    loadNotes: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isInitialized: false };
  }

  componentDidMount() {
    const { params } = this.props;
    // Without a questionnaire id the notes route cannot be built at all.
    if (!params.playerQuestionnaireId) return;
    this.props.loadNotes(params, { source: 'init' });
    this.setState({ isInitialized: true });
  }

  render() {
    const { isLoading, params, survey, player } = this.props;
    if (!params.playerQuestionnaireId) return null;
    if (!this.state.isInitialized || isLoading) {
      return (
        <div className='column u-margin-top--base u-margin-bottom--base'>
          <LoadingSpinner />
        </div>
      );
    }
    return <SurveyNotesContainer params={params} survey={survey} player={player} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: getLoaders(state, ['WEBNOTES']),
    survey: resolveNotesSurvey(state, ownProps),
    player: resolveNotesPlayer(state, ownProps),
    params: {
      playerId: resolveNotesPlayerId(state, ownProps),
      playerQuestionnaireId: resolveNotesQuestionnaireId(state, ownProps),
    },
  }
}

export default connect(mapStateToProps, { loadNotes })(SurveyNotesModal);
